<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{aLang.c_list}} {{aLang.tgl_title}}
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <!-- <div class="text-left">
          <b-collapse v-bind:visible="mData.tableRules.showFormSearch" id="myFormSearch">
            <b-card>
              <el-form
                ref="myForm"
                label-position="top"
                @submit.native.prevent
                :model="mData.tableRules.dataSearch.value"
                :rules="mData.tableRules.dataSearch.valid"
              >
                <b-row>
                  <b-col md="3">
                    <el-form-item label="Họ tên" prop>
                      <el-input
                        v-model="mData.tableRules.dataSearch.value['ho_ten.ho_ten']"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Email" prop>
                      <el-input v-model="mData.tableRules.dataSearch.value['email']" clearable></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Điện thoại" prop>
                      <el-input
                        type="number"
                        v-model="mData.tableRules.dataSearch.value['dien_thoai']"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Số thẻ hướng dẫn viên" prop>
                      <el-input
                        type="number"
                        v-model="mData.tableRules.dataSearch.value['the_hdv.so_the']"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button
                    type="info"
                    native-type="submit"
                    v-ladda
                    plain
                    @click="fn_tableSearch()"
                  >{{aLang.c_search}}</el-button>
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col md="8" class="p-0">
            <b-col md="4"></b-col>
          </b-col>
          <b-col md="4">
            <div class="text-right mb-2">
              <el-button
                @click="fn_tableShowFormSearch()"
                type="info"
                plain
              >{{aLang.c_showHideSearch}}</el-button>
            </div>
          </b-col>
        </b-row>-->

        <el-table
          :data="mData.tableRules.data"
          border
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          max-height="440"
          style="width: 100%"
          :default-sort="{prop: mData.tableRules.defaultSort[0], order: mData.tableRules.defaultSort[1]}"
        >
          <el-table-column type="selection" width="40" v-if="mData.tableRules.allowSelect"></el-table-column>
          <el-table-column
            prop="ho_ten"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.tgl_fullname"
            min-width="200"
          >
            <template slot-scope="scope">
              <el-link
                class="cell-child"
                target="_blank"
                @click="fn_handle('detail',scope.$index, scope.row)"
                :underline="false"
              >{{scope.row.ho_ten}}</el-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="so_the"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.tgl_card_number"
            width="200"
            align="right"
          ></el-table-column>
          <el-table-column
            prop="so_tour"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.tgl_number_of_tour_led"
            width="200"
            align="right"
          ></el-table-column>

          <el-table-column prop="so_sao" :label="aLang.tgl_evaluate" width="100" align="center">
            <template slot-scope="scope">
              <el-link
                class="cell-child"
                target="_blank"
                @click="fn_goDanhGia('detail',scope.$index, scope.row)"
                :underline="false"
              >{{scope.row.so_sao}}</el-link>
            </template>
          </el-table-column>

          <el-table-column :label="aLang.c_action" align="center" width="150px">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="fn_handle('detail',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_detail"
              >
                <i class="fa fa-eye"></i>
              </el-button>
              <!-- <el-button
                size="mini"
                @click="fn_handle('update',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_update"
              >
                <i class="icon-pencil icons"></i>
              </el-button>-->
              <!-- <el-button
                size="mini"
                @click="fn_handle('delete',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_delete"
              >
                <i class="icon-trash icons"></i>
              </el-button>-->
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div
              v-if="mData.tableRules.allowSelect"
            >{{aLang.c_select}}: {{mData.tableRules.recordSelected.length}}</div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="mData.tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import HuongDanVienModel from "./HuongDanVienModel";
import HuongDanVienApi from "../../../moduleApi/HuongDanVienApi";
import DanhGiaApi from "../../../moduleApi/DanhGiaApi";
import TourApi from "../../../moduleApi/TourApi";

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        moduleName: "HuongDanVienDaDan", //requied
        tableRules: {
          data: [],
          lengthMenu: [10, 20, 50, 100, 500],
          allowPaging: false,
          allowSorting: false,
          allowSelect: false,
          showFormSearch: false,
          showUrl: false,
          total: 0,
          page: 1,
          limit: 10,
          offset: 0,
          sort: "",
          defaultSort: ["ho_ten.ten", "ascending"],
          filters: "",
          recordSelected: [],
          dataSearch: HuongDanVienModel.dataSearch
        },
        dataDefault: {
          roles: DataService.roles,
          listCongTyLuHanh: [],
          listStar: [],
          listAmountTour: []
        }
      }
    };
  },

  methods: {
    //get list table
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters,
        fields:
          "id,ho_ten,email,dien_thoai,gioi_tinh,ngay_sinh,giay_to,quoc_tich,dia_chi,avatar_id,the_hdv,ngoai_ngu,so_truong,thanh_tich,lich_su_hanh_nghe"
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }

      if (this.mData.tableRules.showUrl) {
        this.$router.replace({
          name: "Admin-" + this.mData.moduleName + "-list",
          query: {
            limit: this.mData.tableRules.limit,
            page: this.mData.tableRules.page,
            sort: this.mData.tableRules.sort,
            filters: this.mData.tableRules.filters,
            showFormSearch: this.mData.tableRules.showFormSearch
          }
        });
      }

      // let res = await HuongDanVienApi.list(dataFilter);
      let res = await HuongDanVienApi.getListHuongDanVienDaDan();

      let huongDanVienIds = [];
      huongDanVienIds = MethodService.findListItemDifferent(res.result, "id");

      if (huongDanVienIds.length > 0) {
        //get Danh gia
        let resDanhGia = await DanhGiaApi.getStar(huongDanVienIds);
        this.mData.dataDefault.listStar = resDanhGia.result;
        //get số tour đã dẫn
        let resAmountTour = await TourApi.getTourCountByTourGuideIds(
          huongDanVienIds
        );
        this.mData.dataDefault.listAmountTour = resAmountTour.result;

        for (var itemData in res.result) {
          if (
            this.mData.dataDefault.listStar.find(
              item => item.id === res.result[itemData].id
            )
          ) {
            res.result[itemData].so_sao =
              Math.round(
                this.mData.dataDefault.listStar.find(
                  item => item.id === res.result[itemData].id
                ).star
              ) + "/5";
          } else {
            res.result[itemData].so_sao = null;
          }
          if (
            this.mData.dataDefault.listAmountTour.find(
              item => item.id === res.result[itemData].id
            )
          ) {
            res.result[
              itemData
            ].so_tour = this.mData.dataDefault.listAmountTour.find(
              item => item.id === res.result[itemData].id
            ).count;
          } else {
            res.result[itemData].so_tour = 0;
          }
        }
      }

      this.mData.tableRules.data = this.changeData(res.result);
    },

    //xử lý dữ liệu đầu ra
    changeData(data) {
      $.each(data, (index, item) => {
        if (item.gioi_tinh != undefined) {
          let gt = DataService.gioiTinh.find(element => {
            return element.id == item.gioi_tinh;
          });
          if (gt) {
            item.gioi_tinh = gt.text;
          }
        }
        if (item.ngay_sinh != undefined) {
          item.ngay_sinh.ngay_sinh = new Date(
            item.ngay_sinh.nam,
            item.ngay_sinh.thang - 1,
            item.ngay_sinh.ngay
          ).toUTCString();
          // item.ngay_sinh.ngay + "/" + item.ngay_sinh.thang + "/" +item.ngay_sinh.nam;
        }
      });
      return data;
    },

    fn_goDanhGia(type, scope, row) {
      if (type == "detail") {
        this.$router.push({
          name: "Admin-DanhGia-list",
          query: {
            filters: "doi_tuong_danh_gia_id:in:" + row.id
          }
        });
      }
    },

    //click button
    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-HuongDanVien-create"
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-HuongDanVien-update",
          params: { id: row.id }
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-HuongDanVienDaDan-detail",
          params: { id: row.id }
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
      if (type == "disable") {
        this.$confirm(LanguageService.lang.user_disableConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_disable(row.id, true);
          })
          .catch(() => {});
      }
      if (type == "openDisable") {
        this.$confirm(LanguageService.lang.user_openDisableConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_disable(row.id, false);
          })
          .catch(() => {});
      }
    },

    //delete
    async fn_delete(id) {
      await HuongDanVienApi.delete(id);
      this.fn_initTable();
    },

    //khóa tài khoản
    async fn_disable(id, disable) {
      await HuongDanVienApi.disable(id, disable);
      this.fn_initTable();
    },

    //event table

    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function(element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        if (column.prop == "ngay_sinh.ngay_sinh") {
          this.mData.tableRules.sort = "ngay_sinh.nam,ngay_sinh.thang";
        } else {
          if (column.prop == "ho_ten.ho_ten") {
            this.mData.tableRules.sort = "ho_ten.ten,ho_ten.ho";
          } else {
            this.mData.tableRules.sort = column.prop;
          }
        }
      } else if (column.order == "descending") {
        if (column.prop == "ngay_sinh.ngay_sinh") {
          this.mData.tableRules.sort = "-ngay_sinh.nam,-ngay_sinh.thang";
        } else {
          if (column.prop == "ho_ten.ho_ten") {
            this.mData.tableRules.sort = "-ho_ten.ten,-ho_ten.ho";
          } else {
            this.mData.tableRules.sort = "-" + column.prop;
          }
        }
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    // search
    fn_tableSearch() {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          var filters = "";
          console.log(this.mData.tableRules.dataSearch.value);

          $.each(this.mData.tableRules.dataSearch.value, (key, value) => {
            if (value) {
              if (this.mData.tableRules.dataSearch.operator[key]) {
                filters +=
                  key +
                  this.mData.tableRules.dataSearch.operator[key] +
                  value +
                  "&";
              } else {
                filters += key + "=" + value + "&";
              }
            }
          });
          filters = filters.slice(0, -1);
          this.mData.tableRules.filters = filters;
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.fn_initTable();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query
      });
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterRoles(row, column, cellValue, index) {
      var roles = "";
      cellValue.forEach(item => {
        for (let i = 0; i < this.mData.dataDefault.roles.length; i++) {
          if (item == this.mData.dataDefault.roles[i].value) {
            item = this.mData.dataDefault.roles[i].label;
            roles += item + " ,";
          }
        }
      });
      roles = roles.slice(0, -1);
      return roles;
    },

    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
    }
  },

  //run after render view
  created() {
    this.fn_hashUrl();
  },
  mounted() {
    this.fn_initTable();
  }
};
</script>
